import React from "react"

import Card, {SkillsList} from "./Card.js" 
import dataInfo from "../data.js"
import tom from "../assets/profile7.png"
import linkedInLogo from "../assets/linkedin.png"
import githubLogo from "../assets/github-mark-white.png"
import gmailLogo from "../assets/Gmail_Logo_512px.png"

import skillsInfo from "../skills.js"
import { Link } from "react-router-dom";

// import {skillsList} from 
export default function Main()
{

    const content = dataInfo.map( function(item) 
    {
        return < Card 
        img={item.coverImg}
        summary={item.summary}
        pageLink = {item.pageLink}
        title={item.title}
        /> 
    })



    return (
        <main className="mainDiv" id="about">

            <div class="aboutContainer">

                <div class="aboutLeft">
                    <img src={tom} alt="Image" />
                 </div>

                <div class="aboutRight">

                    <h1>
                        About
                    </h1>

                    <p>
                    Hello, I'm Divyam, a Computer Vision developer at  
                    <a href="https://www.valcomelton.com/en/industrial-products/inspection-cameras-sensors/clearvision-camera-systems" target="_blank"> ClearVision Technologies </a>                     
                    in Vancouver. I develop and maintain the end-to-end vision pipeline for real time object detection systems, 
                    including their optimized deployment. 
                    
                    <br/>  <br/> 

                    I completed my master's from Carleton University, Ottawa in July 2025, where my thesis was focused on 
                    multi-sensor calibration (details in Projects section). 

                    My interests lie in R&D in multi-sensor vision systems, with a focus on DSP, deep learning, optimization, 
                    and areas like stereo vision and SLAM. 
                    I primarily use C++ for implementation and Python for rapid prototyping and model training.
                                         
                    <br/>  <br/>             

                    Outside of work, I enjoy cooking and capturing some 360° videos.
                    <br/>  
                    (Last Updated- April, 2026)

                    </p> 

                </div>


            </div>

            <div class="projectsDiv" id="projects">
                <h1>
                    Projects
                </h1>
            </div>

            <div class="contacts">

                    {content} 

            </div>

            <div class="skillsDiv" id="skills">
                <h1 > 
                    Skills / Interests
                </h1>

                < SkillsList /> 

            </div>


            <div class='addResDiv'>
                <h1>
                    Additional Resources 
                </h1>

                <ul>
                {/* https://www.coursera.org/learn/machine-learning */}
                    <li> Did this classic course on <a href="https://www.coursera.org/learn/machine-learning"   target="_blank">
                     Machine Learning by Andrew Ng</a>.
                     Here are &nbsp;
                     <a href="https://drive.google.com/file/d/19ZvatTzAUvnJV0M2Rj93Xw_gQnvmeFll/view?usp=sharing"   target="_blank">
                      my notes  
                     </a>
                     &nbsp; of the same
                       </li>
                    <li> 
                        <a href="https://drive.google.com/file/d/1piTlnmg2SzJC7aye5xMEMCvBKn8AJJ8f/view?usp=sharing"   target="_blank"> Notes </a>
                             of this &nbsp;
                        <a href="https://www.coursera.org/learn/convolutional-neural-networks" target="_blank"> 
                            Convolutional Neural Network
                        </a> course  
                        </li>
                    
                    <li> 

                            Here is an <a href="https://www.youtube.com/watch?v=ANszao6YQuM&list=PLoROMvodv4rOABXSygHTsbvUz4G_YQhOb&index=5"  target="_blank" > 
                    awesome lecture 
                     </a> on adverserial attacks by Stanford. &nbsp; 
                     <a href="https://drive.google.com/file/d/1ehyEd4gSyekTkyAQblQIHSZzX8XVUJgg/view?usp=sharing" target="_blank">
                            View notes
                        </a> 
                     </li>

                    <li> Hands down the best course on the internet on &nbsp;
                        <a href="https://ocw.mit.edu/courses/18-06-linear-algebra-spring-2010/video_galleries/video-lectures/"   target = "_blank"> 
                        Linear Algebra by Prof. Strang. </a>
                        Here it is as captured in 
                     <a href="https://drive.google.com/file/d/19YDKnkDIykn4Opw0hMMVWY5MlTBnDJHE/view?usp=drive_link"  target="_blank" > my notes  </a>  </li>
                </ul>

            </div>

            <div class="contactDiv" id="contacts">
                <h1>
                    Contact
                </h1>
                <div class="contactsLogoDiv">

                    
                    <a  href="https://www.linkedin.com/in/sharmadivyam/"  target="_blank" >
                        <img src={linkedInLogo} alt="Linkedin" />
                    </a>

                    <a href="mailto:divyam04sharma@gmail.com" >
                        <img src={gmailLogo} alt="Image" />
                    </a>

                    <a  href="https://github.com/Divyam04/"  target="_blank" >
                        <img src={githubLogo } alt="Github link" />
                    </a>


                 </div>

            </div>

            {/* <div class='miscDiv'>
                <h1>
                    Misc (Non  Tech)
                </h1>

            </div> */}



        </main>

    )
}